export enum EPaymentSessionStatus {

    /**
     * 等待支付
     */
    PENDING = 'pending',
    /**
     * 支付处理中
     */
    PROCESSING = 'processing',
    /**
     * 已支付
     */
    COMPLETED = 'completed',
    /**
     * 已取消
     */
    CANCELLED = 'cancelled',

    /**
     * @deprecated 退款中(兼容)
     */
    REFUNDING = 'refunding',
    /**
     * @deprecated 已退款(兼容)
     */
    REFUNDED = 'refunded',
    /**
     * @deprecated 已失败（系统故障）
     */
    FAILED = 'failed',
    /**
     * @deprecated 已过期
     */
    EXPIRED = 'expired',
    /**
     * @deprecated 充值中(兼容)
     */
    CHARGE_PENDING = 'charge_pending'

}

export enum EPaymentMethod {
    PAYPAL = 'paypal',
    PAYONEER = 'payoneer',
    ADYEN = 'adyen',
}

export interface ICreatePaymentSessionArgs {

    /**
     * 订单 id
     * 支付场景下必填
     * 取值范围: uint64 字符串
     */
    order?: string;

    /**
     * 订阅 id
     * 开启自动续费场景下必填
     */
    subscriptionId?: string;

    /**
     * 支付方式
     *
     * - paypal
     * - payoneer
     */
    paymentMethod: EPaymentMethod;

    /**
     * 用于前台跳转的链接
     *
     * 取值范围： 1-255 个字符
     */
    redirectUrl: string;

    /**
     * 支付界面多语言参数
     *
     * 取值范围： 1-64 个字符
     */
    lang?: string;

    /**
     * 支付网关所需的额外数据
     */
    extraData?: any;
}

export interface ICreatePaymentSessionRes {

    /*
     * 支付单 id
     */
    paymentId?: string;

    /*
     * 和第三方支付网关的支付会话 Id
     */
    sessionId: string;

    /*
     * payment session 使用到的商户 clientId
     * > 目前仅供 paypal sdk 使用
     */
    clientId?: string;

    /**
     * 支付跳转链接
     */
    url: string;

    /**
     * 客户端支付 token
     *
     * */
    customerIdToken?: {

        /**
         * 客户免密支付 token
         *
         * */
        token: string;

        /**
         * token 过期时间
         *
         * */
        expiresIn: number;
    };

    /**
     * 网关的特有支付会话信息
     */
    details: any;

}

export interface IPaymentMethod {

    /**
     * 支付方式名称
     *
     * 长度： 0 ~ 64
     */
    'gateway': string;

    /**
     * 支付方式状态
     *
     * * disable 为不可用
     * * enable 为可用
     */
    'status': 'disable' | 'enable';

    /**
     * 支付方式配置
     *
     * 用于前台显示配置，包括支付按钮显示设置/支付方式显示开关等
     */
    'style': { hideAutoRenew?: boolean;availableCountries?: string[];disableFundings?: string[]; } & Record<string, unknown>;

    /**
     * 支持自动续费的国家列表
     */
    supportPasslessCountries?: string[];

}

export interface IApprovePaymentRes {

    /**
     * 支付记录的状态。
     */
    'status': EPaymentSessionStatus;

    /**
     * 用于前台跳转的链接
     *
     */
    redirectUrl: string;
}

export type TCancelPaymentRes = IApprovePaymentRes;

export type TGetPaymentResultRes = IApprovePaymentRes;

export interface ICreateBillingAgreementSessionRes {

    /*
     * payment session 使用到的商户 clientId
     *
     */
    clientId: string;

    /**
     * 客户端支付 token
     *
     * */
    customerIdToken: {

        /**
         * 客户免密支付 token
         *
         * */
        token: string;

        /**
         * token 过期时间
         *
         * */
        expiresIn: number;
    };

    /*
     * 签约 session 使用到的会话 token
     *
     */
    setupToken: string;
}

export interface IBillingAgreementItem {

    /**
     * 合约 id
     *
     */
    'id': string;

    /**
     * 支付网关名称
     *
     * 长度： 0 ~ 64
     */
    'gateway': 'paypal' | string;

    /**
     * 支付合约状态
     *
     * * disable 为不可用
     * * enable 为可用
     *
     */
    'status': 'disable' | 'enable';

    /**
     * 用户支付网关账号
     *
     * 长度： 0 ~ 255
     */
    'gatewayAccount': string;

    /**
     * 支付方式的排序值，越小则越靠前，只有 status 的值为 enable 时，才有此值
     * 值最小为1，依次递增
     */
    'sort'?: number;

    /**
     * 更新时间
     */
    'modifiedAt': number;

}

export interface IGetPaymentMethodsArgs {
    'order-id'?: string;
    /**
     * 订阅id，针对没有订单id的场景(比如订阅的自动续费)则需要传递该值
     */
    'subscription-id'?: string;
}
export interface IGetPaymentMethodsRes {
    items: IPaymentMethod[];
    rel?: {
        sort: string[];
    };
}
